const aboutAcademy = {
  // HeroSection
  'aboutAcademy.hero.homeLink': 'ホーム',
  'aboutAcademy.hero.currentPage': '日本執事アカデミーとは',
  'aboutAcademy.hero.title': '日本執事アカデミーとは',
  'aboutAcademy.hero.titleEn': 'THE JAPAN BUTLER ACADEMY',
  'aboutAcademy.hero.lead': '日本執事アカデミーとは、一般社団法人全日本執事協会が運営する執事の教育機関です。東京・お台場にて対面で通える、日本で唯一の学び舎を持つ執事養成学校として、3つのコースと協会認定資格を備えています。',
  'aboutAcademy.hero.imgAlt': '東京湾を望むテラスに立ち、湾岸の景色へ視線を向ける執事',

  // Identity section
  'aboutAcademy.identity.label': 'WHO WE ARE',
  'aboutAcademy.identity.title': '日本執事アカデミーという学び舎',
  'aboutAcademy.identity.subtitleEn': 'The Institution Behind the Name',
  'aboutAcademy.identity.lead': '一文で申し上げれば、日本執事アカデミーとは「一般社団法人全日本執事協会が東京・お台場で運営する、執事の養成と認定を担う専門の学び舎」です。ここでは運営母体・校舎・役割という三つの側面から、当校の身元をそのままご説明します。',
  'aboutAcademy.identity.1.sub': '名称と役割 — 執事を育て、認定する専門機関',
  'aboutAcademy.identity.1.body': '日本執事アカデミーは、執事という職業に必要な所作・接遇・家政管理を体系立てて指導する専門機関の名称です。人材の紹介や仲介を行う会社ではなく、受講生を教室で指導し、修了時の実技試験を経て協会認定資格を授与するところまでを一貫して担います。執事学校という言葉で当校をお探しになった方には、まず「教える側の機関である」という点をご確認いただければと存じます。',
  'aboutAcademy.identity.1.imgAlt': '重厚な調度が並ぶ応接室に佇む執事',
  'aboutAcademy.identity.2.sub': '運営母体 — 一般社団法人全日本執事協会',
  'aboutAcademy.identity.2.body': '当校を運営しているのは、一般社団法人全日本執事協会です。協会は執事の育成、資格の認定、企業向けの接遇・ビジネスマナー研修、修了生へのキャリア支援（準備中）を事業として掲げており、日本執事アカデミーはそのうち「育成」を受け持つ教育部門にあたります。指導する側と認定する側が同じ協会に属しているため、教室で扱う内容と資格の基準がひとつの体系として結ばれている——これが執事養成学校としての当校の構造上の特徴です。\n\n協会の創立は1890年（明治23年）にさかのぼり、一般社団法人としての設立は2025年2月19日です。代表者は、一般社団法人全日本執事協会 代表理事の石井裕一（執事ベル／三代目頭取）が務めています。',
  'aboutAcademy.identity.2.imgAlt': '金彩の皿とリボンで束ねた巻物、真鍮の印章が並ぶ静物',
  'aboutAcademy.identity.3.sub': '学び舎 — 東京・お台場の本校',
  'aboutAcademy.identity.3.body': '対面授業は、東京都江東区青海にある本校で行います。ゆりかもめ「東京国際クルーズターミナル駅」「テレコムセンター駅」のいずれからも徒歩約5分という立地で、受講生が実際に足を運んで実技に取り組める教室です。この東京・お台場の本校を構えていることこそ、日本執事アカデミーが日本で唯一の学び舎を持つ執事養成学校であると申し上げられる根拠です。\n\n執事学校をお探しになるうえで校舎の有無を重んじる方には、まず本校をご覧いただくのが早道かと存じます。ご来訪はすべて完全予約制とし、見学・個別相談・体験講座を事前予約にて承っています。',
  'aboutAcademy.identity.3.imgAlt': 'お台場エリアに建つ校舎の吹き抜けアトリウム',

  // Programme overview
  'aboutAcademy.programme.label': 'PROGRAMMES',
  'aboutAcademy.programme.title': '3つのコースで構成される本科',
  'aboutAcademy.programme.subtitleEn': 'The Three Programmes',
  'aboutAcademy.programme.lead': '日本執事アカデミーの本科は、エッセンシャル・アドバンス・マスターの3コースで構成されています。基礎から応用、管理へと深まる積み上げ式で、上位コースが下位の内容を含むため、受講は原則としてひとつをお選びいただく形です。ここでは各コースの段階のみをご紹介し、日数や受講料などの条件はコース一覧・比較ページに譲ります。',
  'aboutAcademy.programme.metaLabel': '学びの段階',
  'aboutAcademy.programme.1.title': 'エッセンシャル｜基礎のコース',
  'aboutAcademy.programme.1.meta': '所作の土台',
  'aboutAcademy.programme.1.desc': '執事の基本所作と接遇の型を集中して身につける、入口にあたるコースです。',
  'aboutAcademy.programme.1.imgAlt': 'ワードローブでモーニングコートにブラシをかける執事',
  'aboutAcademy.programme.2.title': 'アドバンス｜応用のコース',
  'aboutAcademy.programme.2.meta': '応用と広がり',
  'aboutAcademy.programme.2.desc': 'エッセンシャルの内容を含んだうえで、より高度な接遇技術と特別実習まで踏み込むコースです。未経験からの直接受講もできます。',
  'aboutAcademy.programme.2.imgAlt': '燭台にろうそくの灯をともす白手袋の執事の手元',
  'aboutAcademy.programme.3.title': 'マスター｜管理と危機対応のコース',
  'aboutAcademy.programme.3.meta': '管理と判断',
  'aboutAcademy.programme.3.desc': 'エッセンシャルとアドバンスの内容を含み、管理と危機対応までを修める最上位のコースです。こちらも未経験から直接受講いただけます。',
  'aboutAcademy.programme.3.imgAlt': 'イルミネーションの並木道で車の乗降をサポートする執事',
  'aboutAcademy.programme.link': 'コース一覧・比較ページで条件を確認する',

  // Class format
  'aboutAcademy.format.label': 'HOW CLASSES ARE HELD',
  'aboutAcademy.format.title': '通っていただく形',
  'aboutAcademy.format.subtitleEn': 'The Shape of Our Classes',
  'aboutAcademy.format.lead': '開催曜日・クラスの規模・対面とオンデマンドの組み合わせ——この三点が、日本執事アカデミーの授業の形を決めています。いずれも、働きながら学ぶ方が無理なく通い続けられることを優先して定めた条件です。',
  'aboutAcademy.format.1.title': '土日開催',
  'aboutAcademy.format.1.desc': '授業はすべて土曜・日曜に実施します。現職を離れずに週末で通うことを前提とした開催形態です。',
  'aboutAcademy.format.2.title': '定員6名の少人数制',
  'aboutAcademy.format.2.desc': '1クラスの定員は6名です。講師が全員の所作に目を通せる規模に絞っており、最少催行人数は3名としています。',
  'aboutAcademy.format.3.title': '対面とオンデマンド動画の併用',
  'aboutAcademy.format.3.desc': '本校での対面授業に、予習・復習用のオンデマンド動画講座を組み合わせます。対面の時間を実技と質疑に充てるための構成です。',

  // Certification & corporate
  'aboutAcademy.outcome.label': 'WHAT WE PROVIDE',
  'aboutAcademy.outcome.title': '修了で得られるもの／法人のお客様への研修',
  'aboutAcademy.outcome.subtitleEn': 'Certification and Corporate Training',
  'aboutAcademy.outcome.lead': '当校が世に出しているものは、修了生に授与する認定資格と、企業・団体へお届けする接遇研修の二つです。性格が異なりますので、混同のないよう分けてご説明します。',
  'aboutAcademy.outcome.cert.title': '協会認定のバトラー資格',
  'aboutAcademy.outcome.cert.body': '各課程の修了時には実技試験があり、合格された方には全日本執事協会が認定するバトラー資格を授与します。国家資格ではなく協会が独自に認定する民間資格で、階級は3段階に分かれています。当校が指導した技能の水準を、この認定で示しています。',
  'aboutAcademy.outcome.cert.link': '修了証・認定資格について見る',
  'aboutAcademy.outcome.corp.title': '法人・団体向けの接遇研修',
  'aboutAcademy.outcome.corp.body': '日本執事アカデミーが担うのは本科の指導だけではありません。企業・団体向けの接遇およびビジネスマナー研修も、同じ講師陣が出張または来校の形式で担当します。ただしこちらは執事の接遇スキルに基づく教育プログラムであり、受講者に執事資格を付与するものではありません。',
  'aboutAcademy.outcome.corp.link': '法人研修のご案内を見る',
  'aboutAcademy.outcome.corp.imgAlt': '会議室で受講者に向けて接遇の所作を説明する執事講師',

  // Overview table
  'aboutAcademy.overview.label': 'THE FACTS',
  'aboutAcademy.overview.title': '所在地とお問い合わせ',
  'aboutAcademy.overview.subtitleEn': 'Where to Find Us',
  'aboutAcademy.overview.lead': '当校の基本事項を一覧にまとめました。ご来訪の前に、開催曜日と予約の要否をあわせてご確認ください。',
  'aboutAcademy.overview.0.label': '名称',
  'aboutAcademy.overview.0.value': '日本執事アカデミー',
  'aboutAcademy.overview.1.label': '運営',
  'aboutAcademy.overview.1.value': '一般社団法人全日本執事協会',
  'aboutAcademy.overview.2.label': '代表者',
  'aboutAcademy.overview.2.value': '石井裕一（執事ベル）／一般社団法人全日本執事協会 代表理事（三代目頭取）',
  'aboutAcademy.overview.3.label': '所在地',
  'aboutAcademy.overview.3.value': '〒135-0064 東京都江東区青海2丁目7-4（お台場）',
  'aboutAcademy.overview.4.label': '最寄り駅',
  'aboutAcademy.overview.4.value': 'ゆりかもめ「東京国際クルーズターミナル駅」「テレコムセンター駅」より徒歩約5分',
  'aboutAcademy.overview.5.label': '電話',
  'aboutAcademy.overview.5.value': '03-6824-4086（受付 平日10:00〜17:00）',
  'aboutAcademy.overview.6.label': 'メール',
  'aboutAcademy.overview.6.value': 'info@butler-academy.jp',
  'aboutAcademy.overview.7.label': '授業',
  'aboutAcademy.overview.7.value': '土日開催／1クラス定員6名（最少催行3名）',
  'aboutAcademy.overview.8.label': 'ご来訪',
  'aboutAcademy.overview.8.value': '完全予約制（見学・個別相談・体験講座）',
  'aboutAcademy.overview.note': '※資料請求と個別相談は無料で承っています。ご来訪の際は事前にご予約ください。',
  'aboutAcademy.overview.accessLink': 'アクセスの詳細を見る',

  // FAQ
  'aboutAcademy.faq.label': 'FAQ',
  'aboutAcademy.faq.title': 'この学び舎についてのご質問',
  'aboutAcademy.faq.subtitleEn': 'Frequently Asked Questions',
  'aboutAcademy.faq.footer': 'ここに載っていないご質問は、お問い合わせフォームよりお寄せください。',
  'aboutAcademy.faq.q1': '日本執事アカデミーは何をするところですか？',
  'aboutAcademy.faq.a1': '執事に必要な所作・接遇・家政管理を指導し、修了時の実技試験を経て協会認定資格を授与する教育機関です。運営は一般社団法人全日本執事協会が行っています。',
  'aboutAcademy.faq.q2': '運営しているのはどこですか。学校法人ですか？',
  'aboutAcademy.faq.a2': '運営母体は一般社団法人全日本執事協会です。学校法人ではなく、協会が運営する民間の執事養成学校であり、授与する資格も協会独自の民間資格です。',
  'aboutAcademy.faq.q3': '校舎はどこにありますか？',
  'aboutAcademy.faq.a3': '東京都江東区青海2丁目7-4（お台場）に本校があります。ゆりかもめ「東京国際クルーズターミナル駅」「テレコムセンター駅」からいずれも徒歩約5分です。ご来訪は完全予約制です。',
  'aboutAcademy.faq.q4': 'どのコースから受講できますか？',
  'aboutAcademy.faq.a4': 'エッセンシャル・アドバンス・マスターのいずれからでも受講できます。上位のコースが下位のコースの内容を含むため、目的に合うひとつをお選びいただければ必要な範囲を学べます。アドバンスとマスターは未経験からの直接受講も可能です。',
  'aboutAcademy.faq.q5': '見学や相談はできますか？',
  'aboutAcademy.faq.a5': 'はい。見学・個別相談・体験講座を、いずれも完全予約制で承っています。お電話（03-6824-4086・平日10:00〜17:00）、メール（info@butler-academy.jp）、お問い合わせフォームのいずれかからご予約ください。資料請求と個別相談は無料です。',

  // CTA
  'aboutAcademy.cta.label': 'NEXT STEP',
  'aboutAcademy.cta.title': '当校のことを、もう少し詳しく',
  'aboutAcademy.cta.body': '資料請求と個別相談は無料です。お台場の校舎の見学も、あわせて承っています。',
  'aboutAcademy.cta.note': '※ご相談はオンラインでも承ります',
  'aboutAcademy.cta.brochure': '資料請求はこちら（無料）',
  'aboutAcademy.cta.consultation': '個別相談を予約する',

  // Related pages
  'aboutAcademy.related.label': 'LEARN MORE',
  'aboutAcademy.related.title': '関連ページ',
  'aboutAcademy.related.subtitleEn': 'Explore Further',
  'aboutAcademy.related.viewLink': '詳しく見る',
  'aboutAcademy.related.link0.title': '執事学校とは？',
  'aboutAcademy.related.link0.desc': '成り立ちや歴史、世界の潮流から日本での位置づけまで、一般名詞としての執事学校を解説します。',
  'aboutAcademy.related.link1.title': '執事養成学校とは？',
  'aboutAcademy.related.link1.desc': '訓練される技能、期間と費用の考え方、学校の選び方まで、進路検討に役立つ実務ガイドです。',
  'aboutAcademy.related.link2.title': '執事の仕事とは？',
  'aboutAcademy.related.link2.desc': '業務の領域や一日の流れの例、求められる資質を通して、職業としての執事の実像に迫ります。',
  'aboutAcademy.related.link3.title': 'アカデミー概要',
  'aboutAcademy.related.link3.desc': '理念と教育の概要を軸に据え、当校がどのような姿勢で人材を育てるかを俯瞰できます。',
  'aboutAcademy.related.link4.title': '教育理念・方針',
  'aboutAcademy.related.link4.desc': '指導の根底にある考え方をひもとき、カリキュラムを支える教育方針を明らかにします。',
  'aboutAcademy.related.link5.title': '全日本執事協会について',
  'aboutAcademy.related.link5.desc': '運営母体である協会の役割と事業を紹介し、当校の育成がどのような基盤に立つかを示します。',

  // Last updated
  'aboutAcademy.lastUpdated': '最終更新: 2026年7月25日',
};

export default aboutAcademy;
